import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomMUIButton } from '../../../../buttons/CustomMUIButton';
import { ButtonClassNames } from '../../../../../../models/Common';
import { userInfoApi } from '../../../../../../services/apiServices/user/userInfo';
import { useCustomSnackbar } from '../../../../../../hooks/useCustomEnqueueSnackbar';
import { getErrorMessage } from '../../../../../../utils';

interface DeleteBackupPhoneProps {
  phoneNumber: string;
  phoneId: number;
  handleClose: () => void;
}

export const DeleteBackupPhone: FC<DeleteBackupPhoneProps> = ({ phoneId, handleClose, phoneNumber }) => {
  const { t } = useTranslation();
  const { customEnqueueSnackbar } = useCustomSnackbar();
  const [deleteBackupPhoneApi, { isLoading }] = userInfoApi.useDeleteBackupPhoneMutation();

  const handleDeletePhone = async (id: number) => {
    try {
      await deleteBackupPhoneApi({ phoneId: id })
        .unwrap()
        .then(() => {
          customEnqueueSnackbar(t('snackbar.backupPhoneNumberDeleted'), 'warning');
          handleClose();
        });
    } catch (err) {
      const message = getErrorMessage(err);
      customEnqueueSnackbar(message, 'error');
    }
  };

  return (
    <div className="modals">
      <div className="modals__header">
        <article className="modals__header__title">{t('accountSettings.delete?')}</article>
        <p className="modals__header__description">
          {t('accountSettings.wantDeleteBackupNumber')} <strong>+38{phoneNumber}</strong>?
        </p>
      </div>
      <div className="modals__btn-group">
        <CustomMUIButton
          label={t('buttons.delete')}
          handleClick={() => handleDeletePhone(phoneId)}
          className={ButtonClassNames.PrimaryFulfilled}
          isBold
          isLoading={isLoading}
        />
        <CustomMUIButton
          label={t('buttons.cancel')}
          handleClick={handleClose}
          className={ButtonClassNames.SecondaryOutlined}
          isBold
        />
      </div>
    </div>
  );
};
